var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"phrase-renderer-component"},_vm._l((_vm.terms),function(term){return _c('span',{key:term,staticClass:"tag",class:{'tag-neg': term.charAt(0) === '-'}},[_c('span',[_vm._v(_vm._s(term))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }